import React from 'react'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import WalletList from '../../commons/WalletList/WalletList'
import WalletFilters from '../../commons/WalletFilters/WalletFilters'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import BoyWritter from '../../commons/Ilustrations/BoyWritter'
import useWalletContainer from './useWalletContainer'
import styles from './wallet.module.scss'

const WalletContainer = () => {
  const { fetching, hasFilters, isEmpty, wallets } = useWalletContainer()

  return (
    <DefaultLayout>
      <Flex margin="0px 0px 32px 0px">
        <Text size="lg" color="gray" variation="dark" bold value="Carteira" />
      </Flex>

      {(!isEmpty || hasFilters) && <WalletFilters />}

      {!isEmpty && <WalletList wallets={wallets} fetching={fetching} />}

      {isEmpty && (
        <div className={styles.empty}>
          <BoyWritter />
          <Text
            value="Carteira"
            extraBold
            size="lg"
            lineHeight="28px"
            color="gray"
            variation="dark"
            margin="40px 0px 16px 0px"
          />
          <Text
            value={
              hasFilters
                ? 'Nenhum registro encontrado para os filtros selecionados.'
                : 'Ainda não existe nenhum cliente na carteira.'
            }
            size="xs"
            lineHeight="24px"
            color="gray"
            font="custom"
            fontWeight="400"
            className={styles.textCenter}
          />
        </div>
      )}
    </DefaultLayout>
  )
}

export default WalletContainer
